module.exports = __webpack_public_path__ + "static/img/cat.b387c28.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/accessories/thumbnail/cat.png
// module id = 9aLx
// module chunks = 0